<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6" >
            <a-form-model-item label="用户uid" prop="uid">
              <a-input v-model="formInline.uid" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="订单编号" prop="orderNo">
              <a-input
                v-model="formInline.orderNo"
                type=""
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <bargainingOrderContent
          :formInline="formInline"
          ref="isson"
        ></bargainingOrderContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import bargainingOrderContent from "./bargainingOrderContent.vue";

export default {
  components: {
    bargainingOrderContent,

  },
  data() {
    return {
      formInline: {
        uids: "",
        orderNo: "",
        shopId:"",
        endTime: "",
        beginTime: "",
        limit: 10,
        page: 1
      },
      xiala:[]
    };
  },
  methods: {

    storeType(e) {
      this.formInline.store = e
      console.log('oooooooooooooooooop', e)
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.isson.query();
    },
    onChange(date, dateString) {
      console.log(dateString)
      this.formInline.endTime = dateString[1]
      this.formInline.beginTime = dateString[0]
    },
    handleSubmit(e) {
      console.log(this.formInline);
      // console.log(this.$refs.bbb)
    },
    handleChange() {},
    getQue(data) {
      console.log(data)
    },
    resetForm() {
      //this.$refs.ruleForm.resetFields();
      this.$refs.isson.getOrderListData();
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/bargainingOrder/bargainingOrderHome.vue